import { render, staticRenderFns } from "./TopSellingItems.vue?vue&type=template&id=22fcb68e&scoped=true&"
import script from "./TopSellingItems.vue?vue&type=script&lang=js&"
export * from "./TopSellingItems.vue?vue&type=script&lang=js&"
import style0 from "./TopSellingItems.vue?vue&type=style&index=0&id=22fcb68e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fcb68e",
  null
  
)

export default component.exports